import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import cn from 'classnames';
import './NewCircleModalFinal.scss';

import SmartImage from '../../../General/SmartImage';
import Select from '../../../General/Select';
import Loader from '../../../Loader/Loader';

import { isLoggedIn } from '../../../../Helpers/user_helpers';
import { getHierarchyOptions, generateHierarchyOptionValue, expandHierarchyOptionValue } from '../../../../Helpers/shop_helpers';

const NewCircleModalFinal = props => {
  const { shop, selectedCurators, circleTitle, setCircleTitle, circleHierarchy, setCircleHierarchy } = props;

  const activeHierarchyValue = generateHierarchyOptionValue(circleHierarchy.Industry_id, circleHierarchy.Department_id);
  const selectHierarchyValue = value => {
    const { Industry_id, Department_id } = expandHierarchyOptionValue(value);
    const newHierarchy = { Industry_id, Department_id };
    setCircleHierarchy(newHierarchy);
  };

  // Show circles in the final panel
  let curators = [];
  if (selectedCurators.length <= 1) {
    curators = [null, null, selectedCurators[0], null, null];
  } else if (selectedCurators.length <= 3) {
    curators = [null, selectedCurators[1], selectedCurators[0], selectedCurators[2], null];
  } else {
    curators = [selectedCurators[3], selectedCurators[1], selectedCurators[0], selectedCurators[2], selectedCurators[4]];
  }

  // UI
  const [isCreatingCircleForTab, setIsCreatingCircleForTab] = React.useState(null);
  const canCreateCircle = !!circleTitle.length;
  const headToLatestTab = () => headToTab('latest');
  const headToPopularTab = () => headToTab('popular');
  const headToTab = async tab => {
    const createAndHeadToTab = async () => {
      setIsCreatingCircleForTab(tab);
      await props.createCircleAndHeadToTab(tab);
      setIsCreatingCircleForTab(null);
    };

    if (!isLoggedIn(props.user)) {
      props.openAuthModal('register-shopper');
      return;
    } else {
      createAndHeadToTab();
    }
  };

  return (
    <div className='new-circle-modal-final-container'>
      <div className='final-content'>
        <div className='back-container' onClick={props.backFromFinalPanel}>
          <FontAwesomeIcon icon={faChevronLeft} />
          <div className='back-btn-text'>Back</div>
        </div>
        <div className='curator-photos'>
          {curators.map((curator, idx) => {
            if (!curator) return <div key={`empty-curator-${idx}`} />;
            return (
              <div
                className={cn('photo', {
                  first: idx === 0,
                  second: idx === 1,
                  third: idx === 2,
                  fourth: idx === 3,
                  fifth: idx === 4
                })}
                key={curator.id}
              >
                <SmartImage src={curator.image} alt={curator.name} fallbackText={curator.name} />
              </div>
            );
          })}
        </div>
        <div className='circle-title-input-container'>
          <input
            className='circle-title-input'
            autoFocus
            value={circleTitle}
            onChange={e => setCircleTitle(e.target.value)}
            placeholder='Name your Circle'
          />
        </div>
        <div className='trusted-for-select-container'>
          <Select
            noStyling
            options={getHierarchyOptions(shop)}
            value={activeHierarchyValue}
            placeholder='Expertise Focus'
            onChangeValue={selectHierarchyValue}
          />
        </div>
        <div className='action-btns'>
          <div
            onClick={headToPopularTab}
            className={cn('action-btn secondary', { disabled: !canCreateCircle, loading: isCreatingCircleForTab === 'popular' })}
          >
            Shop Most Popular
            {isCreatingCircleForTab === 'popular' && <Loader size={64} />}
          </div>
          <div
            onClick={headToLatestTab}
            className={cn('action-btn primary', { disabled: !canCreateCircle, loading: isCreatingCircleForTab === 'latest' })}
          >
            Shop Latest Finds
            {isCreatingCircleForTab === 'latest' && <Loader size={64} />}
          </div>
        </div>
      </div>
    </div>
  );
};

NewCircleModalFinal.propTypes = {
  user: PropTypes.object.isRequired,
  shop: PropTypes.object.isRequired,
  circleTitle: PropTypes.string.isRequired,
  setCircleTitle: PropTypes.func.isRequired,
  circleHierarchy: PropTypes.object.isRequired,
  setCircleHierarchy: PropTypes.func.isRequired,
  goToPreviousPanel: PropTypes.func.isRequired,
  createCircleAndHeadToTab: PropTypes.func.isRequired,
  backFromFinalPanel: PropTypes.func.isRequired,
  openAuthModal: PropTypes.func.isRequired
};

export default NewCircleModalFinal;
